<template>
    <div>
        <tab-bar direction="horizontal" side="top" :entries="tabBarEntries" />
        <router-view />
    </div>
</template>

<script>
import TabBar from "../../components/tabBar/TabBar";

export default {
    data() {
        return {};
    },
    computed: {
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        tabBarEntries() {
            return [
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.settings",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.pickup"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.settings_delivery",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.delivery"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.settings_dispatch",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.dispatch"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.promo_codes",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.promo_codes"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.closures",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.closures"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.openings",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.openings"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.widget",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.widget"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.cgv",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.cgv"),
                    exactUrlMatching: true,
                },
                {
                    to: {
                        name: "click_and_collect.restaurants.configuration.inputParams",
                        param: { restaurant_id: this.restaurant_id },
                    },
                    title: this.$tl("labels.clickAndCollect.settings.tabs.inputParams"),
                    exactUrlMatching: true,
                },
            ];
        },
    },
    components: {
        TabBar,
    },
    created() {
        if (this.$route.name === "click_and_collect.restaurants.configuration")
            this.$router.push({ name: "click_and_collect.restaurants.configuration.settings" });
    },
};
</script>
